/**
 * @file i18n.js
 * @author yangwei(yangwei14@baidu.com)
 */

window.CONSOLE_LOCALE = CONSOLE_LOCALE;